import { flowRight } from 'lodash';
import React from 'react';
import RichContentViewer from '../rich-content-viewer';
import withFontClassName from '../../hoc/with-font-class-name';
import { Post } from '../../types';
import withDeviceType from '../../hoc/with-device-type';
import { createPostContentPreview } from './create-post-content-preview';
import { connect } from '../../../common/components/runtime-context';
import { RootState } from '../../types/store-types';
import { ForumControllerActions } from '../../types/common-types';

type PostContentProps = {
  className?: string;
  post: Post;
  type: string;
  contentFontClassName: string;
  showSeeMore?: boolean;
  containerWidth: number;
  isMobile: boolean;
  onShowMore?: () => void;
};

export const PostContent: React.FC<PostContentProps> & {
  POST_PAGE: 'postPage';
  FEED_PAGE: 'feedPage';
} = ({
  className,
  post,
  type,
  contentFontClassName,
  showSeeMore = false,
  containerWidth,
  onShowMore = () => {},
}) => {
  const preview = React.useMemo(
    () => createPostContentPreview(containerWidth, onShowMore),
    [containerWidth, onShowMore],
  );
  let postBody;

  if (typeof post.content === 'object') {
    postBody = (
      <div className={contentFontClassName}>
        <RichContentViewer
          key={`${post._id}-${post.editedDate}`}
          initialState={post.content}
          readOnly
          origin="post"
          type={type}
          contentId={post._id}
          preview={showSeeMore ? preview : undefined}
        />
      </div>
    );
  }

  return (
    <article className={className}>
      <div className="post-content__body" tab-index="0">
        {postBody}
      </div>
    </article>
  );
};

PostContent.POST_PAGE = 'postPage';
PostContent.FEED_PAGE = 'feedPage';

const mapRuntimeToProps = (
  state: RootState,
  ownProps: any,
  actions: ForumControllerActions,
  host: any,
) => ({
  containerWidth: (host.dimensions.width || 980) - 40, // removing container paddings
});

export default flowRight(
  withFontClassName,
  withDeviceType,
  connect(mapRuntimeToProps),
)(PostContent);
